import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useCurrencyBuyAdsStore = defineStore('currencyBuyAds', {
  state: () => ({}),
  getters: {},
  actions: {
    async action_getAllCurrencyBuyAds() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2041,
      };
      //console.log('action_getAllCurrencyBuyAdds Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getAllCurrencyBuyAdds Success: ', response);
          return {
            result: true,
            data: response.data.currencyBuyAds
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_removeAd(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2040,
        "currencyBuyAd": payload
      };
      console.log('action_removeAd Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_removeAd Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_addAd(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2039,
        "currencyBuyAd": payload
      };
      console.log('action_addAd Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_addAd Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    }
  }
});
